import type { IconSvgObject } from './types';

const PlaySquareIcon: IconSvgObject = [
  ["path", { d: "M9.5 14.2104V9.78956C9.5 9.00724 10.3578 8.52789 11.0241 8.93791L14.6161 11.1483C15.2506 11.5388 15.2506 12.4612 14.6161 12.8517L11.0241 15.0621C10.3578 15.4721 9.5 14.9928 9.5 14.2104Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21.5 19.5V4.5C21.5 3.39543 20.6046 2.5 19.5 2.5H4.5C3.39543 2.5 2.5 3.39543 2.5 4.5V19.5C2.5 20.6046 3.39543 21.5 4.5 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default PlaySquareIcon;
